import { dateFunc } from "@/components/Functions/dateFunc";
import {
	havingEditPermission,
} from "@/utility/common";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

const amountCellRenderers = (params: any) => {
	const amount = params.data.amount;
	if(amount === null || amount === undefined) return "-";
	let [integerPart, decimalPart] =amount?.toString()?.split('.');
	integerPart = integerPart?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	if (decimalPart > 0) {
		return `${integerPart}.${decimalPart}`;
	  } else {
		return integerPart;
	  }
};
export const useTransactionColumnDefs = (
	Payment: string[],
) => {
	const {caseId}=useParams()

	const { t } = useTranslation();
	return [
		{
			checkboxSelection: havingEditPermission(Payment) ? true : false,
			headerCheckboxSelection: havingEditPermission(Payment) ? true : false,
			headerCheckboxSelectionFilteredOnly: havingEditPermission(Payment)
				? true
				: false,
			width: 50,
			suppressSizeToFit: true,
		},
		{
			field: "serialNumber",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.serialNumber"),
			width: 150,
			sortable: true,
			unSortIcon: true,
			type: "serialNumberType",
			cellRenderer: function (params: any) {
				return <Link className="text-bold-underline" to={`/case/${caseId}/import/${params.data.importJobId}`}>
					  <span className="text-bold-underline">
					  {params.data.serialNumber}              </span>
					</Link> ;
			},
		},
		{
			field: "institutionNumber",
			type: "institutionNumberType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.institutionNumber"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "transitNumber",
            type: "transitNumberType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.transitNumber"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "accountNumber",
			type: "accountNumberType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.accountNumber"),
			sortable: true,
			unSortIcon: true,
			width: 150,
		},
		{
			field: "effectiveDate",
			type: "effectiveDateType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.effectiveDate"),
			width: 150,
			sortable: true,
			unSortIcon: true,
			cellRenderer: function (params: any) {
				return dateFunc(params.data.effectiveDate).formattedDateOnly;
			},
		},
		{
			field: "postingDate",
			type: "postingDateType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.postingDate"),
			width: 150,
			sortable: true,
			unSortIcon: true,
            cellRenderer: function (params: any) {
				return dateFunc(params.data.postingDate).formattedDateOnly;
			},
		},
		{
			field: "groupNumber",
			type: "groupNumberType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.groupNumber"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "subGroupNumber",
			type: "subGroupNumberType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.subGroupNumber"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "debtorCreditorIndicator",
			type: "debtorCreditorIndicatorType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.debtorCreditorIndicator"),
			width: 150,
			sortable: true,
			unSortIcon: true,
			cellRenderer: function (params: any) {
				if (params.data.debtorCreditorIndicator) {
					return t("pages.paymentStatus.bankTransactions.columnDetails.yes");
				}
				else{
					return t("pages.paymentStatus.bankTransactions.columnDetails.no");
				}
			}
		},
		{
			field: "transactionCode",
			type: "transactionCodeType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.transactionCode"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
        {
			field: "description1",
            type: "description1Type",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.description1"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "description2",
			type: "description2Type",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.description2"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "amount",
			type: "amountType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.amount"),
			width: 150,
			sortable: true,
			unSortIcon: true,
            cellClass: "align-right",
			headerClass: "stepHeaderClass",
			cellRenderer: amountCellRenderers,
		},
		{
			field: "currency",
			type: "currencyType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.currency"),
			width: 120,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "immediateAvailability",
			type: "immediateAvailabilityType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.immediateAvailability"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "oneDayAvailability",
			type: "oneDayAvailabilityType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.oneDayAvailability"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
        {
			field: "twoPlusAvailability",
            type: "twoPlusAvailabilityType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.twoPlusAvailability"),
			width: 150,
			sortable: true,
			unSortIcon: true,
		},
		{
			field: "uploadedOn",
			type: "uploadedOnType",
			headerName: t("pages.paymentStatus.bankTransactions.columnDetails.updatedOn"),
			width: 200,
			sortable: true,
			unSortIcon: true,
            cellRenderer: function (params: any) {
                return (
                  dateFunc(params.data.uploadedOn).formattedDateTime +
                  " " +
                  params.data.abbreviation
                );
              },
		},
	];
};

